import { tween } from 'popmotion';

const scrollToPosition = (position) => {
    const animation = tween({
        from: window.scrollY,
        to: position,
    });

    animation.start((value) => {
        window.scrollTo(0, value);
    });
};

export { scrollToPosition };
